import { render, staticRenderFns } from "./UmsUserEditor.vue?vue&type=template&id=57d6668e&"
import script from "./UmsUserEditor.vue?vue&type=script&lang=js&"
export * from "./UmsUserEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports